<!-- <p>Hello</p>
<button (click)="signIn()" [disabled]="loading">Login</button> -->
<link type="text/css" rel="stylesheet" href="https://cdn.firebase.com/libs/firebaseui/4.2.0/firebaseui.css" />
<div id="firebaseui-auth-container"></div>